// TODO: Look into consolidating config and stackProps
export const stackProps = {
  erDev: {
    admins: ['rushinge@ucsb.edu'],
    env: {account: '675855300677', region: 'us-west-2'}, // Oregon
    certArn: 'arn:aws:acm:us-east-1:675855300677:certificate/b0490143-5519-4560-9cc8-5cc92aca1a5e',
    httpSubdomain: 'digiknow-er-dev',
    httpDomainZone: 'sandbox.app.arit.ucsb.edu',
    get httpDomain(): string {
      return `${this.httpSubdomain}.${this.httpDomainZone}`;
    },
    emailOrigin: 'The MarCom Team <no-reply@sandbox.app.arit.ucsb.edu>',
    /** How many seconds until the DB goes to sleep */
    dbPauseTimeoutSeconds: 900,
    retainData: false
  },
  gsDev: {
    admins: ['gscott@ucsb.edu'],
    env: {account: '675855300677', region: 'us-west-2'}, // Oregon
    certArn: 'arn:aws:acm:us-east-1:675855300677:certificate/b0490143-5519-4560-9cc8-5cc92aca1a5e',
    httpSubdomain: 'digiknow-gs-dev',
    httpDomainZone: 'sandbox.app.arit.ucsb.edu',
    get httpDomain(): string {
      return `${this.httpSubdomain}.${this.httpDomainZone}`;
    },
    emailOrigin: 'The MarCom Team <no-reply@sandbox.app.arit.ucsb.edu>',
    /** How many seconds until the DB goes to sleep */
    dbPauseTimeoutSeconds: 300,
    retainData: false
  },
  test: {
    admins: [
      'rushinge@ucsb.edu',
      'gscott@ucsb.edu',
      'maksenova@ucsb.edu',
      'housing-frontdesk@ucsb.edu',
      'gcoulousi@ucsb.edu',
      'housing-mktgasst@ucsb.edu',
      'mktg-asst3@housing.ucsb.edu',
      'chirashima@ucsb.edu',
      'kabrinlee@ucsb.edu'
    ],
    env: {account: '675855300677', region: 'us-west-2'}, // Oregon
    certArn: 'arn:aws:acm:us-east-1:675855300677:certificate/b0490143-5519-4560-9cc8-5cc92aca1a5e',
    httpSubdomain: 'digiknow-test',
    httpDomainZone: 'sandbox.app.arit.ucsb.edu',
    get httpDomain(): string {
      return `${this.httpSubdomain}.${this.httpDomainZone}`;
    },
    emailOrigin: 'The MarCom Team <no-reply@sandbox.app.arit.ucsb.edu>',
    /** How many seconds until the DB goes to sleep */
    dbPauseTimeoutSeconds: 1800,
    retainData: false
  },
  production: {
    admins: [
      'rushinge@ucsb.edu',
      'gscott@ucsb.edu',
      'maksenova@ucsb.edu',
      'housing-frontdesk@ucsb.edu',
      'gcoulousi@ucsb.edu',
      'housing-mktgasst@ucsb.edu',
      'mktg-asst3@housing.ucsb.edu',
      'chirashima@ucsb.edu',
      'kabrinlee@ucsb.edu'
    ],
    env: {account: '332465446158', region: 'us-west-2'}, // Oregon
    certArn: 'arn:aws:acm:us-east-1:332465446158:certificate/fd1fef73-73ab-48d6-bf62-6c3c01df741f',
    httpSubdomain: 'digiknow',
    httpDomainZone: 'app.arit.ucsb.edu',
    get httpDomain(): string {
      return `${this.httpSubdomain}.${this.httpDomainZone}`;
    },
    emailOrigin: 'The MarCom Team <no-reply@app.arit.ucsb.edu>',
    /** How many seconds until the DB goes to sleep */
    dbPauseTimeoutSeconds: 3600,
    retainData: true
  }
};

const config = {
  development: {
    googleAppKey: '36028231689-au59ctk4vbs4tave5ki25s21qo0o3v1b.apps.googleusercontent.com',
    emailSenderAddress: 'rushinge@ucsb.edu'
  },
  test: {
    googleAppKey: '36028231689-au59ctk4vbs4tave5ki25s21qo0o3v1b.apps.googleusercontent.com',
    emailSenderAddress: 'rushinge@ucsb.edu'
  },
  production: {
    googleAppKey: '36028231689-au59ctk4vbs4tave5ki25s21qo0o3v1b.apps.googleusercontent.com',
    emailSenderAddress: 'rushinge@ucsb.edu'
  }
} as Record<string, {googleAppKey: string; emailSenderAddress: string}>;

export default config[process.env.NODE_ENV || 'development'];
